export const LABELS = [
    {
        id: 0,
        name: "Hide",
    },
    {
        id: 1,
        name: "Show",
    },
    {
        id: 2,
        name: "Hide in Website",
    },
];

export const getLabelName = (id) => {
    return LABELS.find((val) => val.id === id)?.name;
};

export const DAY_NAMES = [
    {
        id: 1,
        name: "Monday",
    },
    {
        id: 2,
        name: "Tuesday",
    },
    {
        id: 3,
        name: "Wednesday",
    },
    {
        id: 4,
        name: "Thursday",
    },
    {
        id: 5,
        name: "Friday",
    },
    {
        id: 6,
        name: "Saturday",
    },
    {
        id: 7,
        name: "Sunday",
    },
];

export const REGIONS = [
    {
        id: 1,
        en_name: "Riyadh",
        ar_name: "الرياض",
        country: "sa"
    },
    {
        id: 2,
        en_name: "Medina",
        ar_name: "المدينة المنورة",
        country: "sa"
    },
    {
        id: 3,
        en_name: "Dammam",
        ar_name: "الدمام",
        country: "sa"
    },
    {
        id: 4,
        en_name: "Khamis Mushait",
        ar_name: "خميس مشيط",
        country: "sa"
    },
    {
        id: 1,
        en_name: "Cairo",
        ar_name: "القاهرة",
        country: "eg"
    },
];

export const getGatewayType = (type) => {
    switch (type) {
        case 1:
            return "Paytabs";
        case 2:
            return "Tamara";
        case 3:
            return "Tabby";
        case 4:
            return "STC Pay";
        case 5:
            return "Admin Booking";
        case 6:
            return "Pay on Branch";
        case 7:
            return "Qitaf";
        case 8:
            return "Wallet";
        case 9:
            return "Insurance";
        default:
            return "Okkkk";
    }
};

export const MODULES_NAMES = {
    ADMIN: "admin",
    BRANCHES: "branches",
    COUPONS: "coupons",
    DOCTORS: "doctors",
    JOBS: "jobs",
    REPORTS: "reports",
    NEW_REPORT: "new_report",
    EARNING_REPORT: "earning_reports",
    BOOKINGS_REPORT: "bookings_reports",
    TRANSACTIONS_REPORT: "transactions_reports",
    TRANSACTIONS: "transactions",
    ROLES: "roles",
    SERVICES: "services",
    DEPARTMENTS: "departments",
    USERS: "users",
    TICKETS: "tickets",
    NOTIFICATIONS: "notifications",
    CONTACT_US: "contact-us",
    REQUEST: "request",
    FRANCHISE: "franchise",
    BLOGS: "blogs",
    FAQ: "faq",
    REVIEWS: "reviews",
    MEDICINES: "medicines",
    MONTHLY_REPORT: "monthly_report",
    BANNERS: "banners",
};

export default {
    MODULES_NAMES,
};
